import { useAvatarControllerGetSelection } from '@/api/gen/endpoints';

export const useAvatarSelection = () => {
  const { data, isLoading, isFetching, error } = useAvatarControllerGetSelection();

  return {
    data: data ?? null,
    isLoading,
    isValidating: isFetching,
    isReady: !isLoading && !isFetching && !error,
    error,
  };
};
